import React from 'react';
import PropTypes from 'prop-types';
import Echoes from './components/Echoes';
import QualityRequirement from '../QualityRequirement';

const QualityValue = (props) => {
  const {
    isCurrency,
    quality,
    value,
  } = props;

  const purchaseIsCurrency = isCurrency;

  const purchaseQualityValues = purchaseIsCurrency ? null : { ...quality };

  const qualityImage = purchaseQualityValues
    ? <QualityRequirement data={purchaseQualityValues} tooltipPos="right" type="purchase" key={0} />
    : null;

  if (!purchaseIsCurrency) {
    return (
      <div>
        {qualityImage}
        <span>
          {value}
          {' '}
x
          {' '}
          {quality.name}
        </span>
      </div>
    );
  }

  return <Echoes key={1} value={value} />;
};

QualityValue.displayName = 'QualityValue';

QualityValue.propTypes = {
  isCurrency: PropTypes.bool.isRequired,
  quality: PropTypes.shape({}),
  value: PropTypes.number.isRequired,
};

QualityValue.defaultProps = {
  quality: undefined,
};

export default QualityValue;
